<div class="text-center">
  <div class="login-container" [class.login-container-wide]="state.showManualLogin">
    <div class="card no-margin">
      <div class="content">
        <div class="content">
          <div class="text-center p-bottom-30">
            <h1 class="standard-heading" translate>{{eAuthMessages.LOGIN_HEADING}}</h1>
          </div>

          <!-- SSO buttons -->
          <div class="area-login-option-buttons">
            <div class="area-sso-buttons">
              <div class="area-sso-buttons-inner">
                <ng-container *ngIf="allowedSignInMethods[eAuthType.SSO_MICROSOFT]">
                  <app-login-sso-microsoft-component (buttonClick)="ssoLogin($event)"></app-login-sso-microsoft-component>
                </ng-container>
                <ng-container *ngIf="allowedSignInMethods[eAuthType.SSO_GOOGLE]">
                  <app-login-sso-google-component (buttonClick)="ssoLogin($event)"></app-login-sso-google-component>
                </ng-container>
              </div>
            </div>

            <ng-container *ngIf="allowedSignInMethods[eAuthType.EMAIL_PASSWORD]">
              <ng-container *ngIf="allowedSignInMethods[eAuthType.SSO_MICROSOFT] || allowedSignInMethods[eAuthType.SSO_GOOGLE]">
                <div class="text-center">
                  <h5 class="standard-heading" translate>{{eAuthMessages.PROMPT_ALTERNATE_LOGIN}}</h5>
                </div>
              </ng-container>
  
              <ng-container *ngIf="!state.showManualLogin; else templateUsingPassword;">
                <div class="area-manual-buttons">
                  <app-button [type]="eButtonType.GREEN_INVERTED" [buttonWidth]="'100%'" (onClick)="startManualLogin()">
                    <span translate>{{eAuthMessages.LOGIN_WITH_EMAIL}}</span>
                  </app-button>
                </div>
              </ng-container>
            </ng-container>
          </div>
  
          <ng-template #templateUsingPassword>
            <div class="area-manual-form">
              <div [class.frankli-form-group-invalid]="controlEmail.invalid && state.submitted"
                [class.frankli-form-group-filled]="controlEmail.value" class="frankli-form-group">
                <label for="email" translate>{{eAuthMessages.EMAIL_ADDRESS}}</label>
                <input type="email" id="email" name="email" class="form-control" placeholder="name@company.com"
                  autocomplete="email" [formControl]="controlEmail" (keydown.enter)="login()">
                <div class="frankli-form-group-alert">
                  <ng-container *ngIf="state.submitted">
                    <div *ngIf="controlEmail.hasError('pattern')" translate>{{eCommonMessages.MUST_BE_VALID_EMAIL}}</div>
                    <div *ngIf="controlEmail.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                  </ng-container>
                </div>
              </div>
    
              <div [class.frankli-form-group-invalid]="controlPassword.invalid && state.submitted"
                [class.frankli-form-group-filled]="controlPassword.value" class="frankli-form-group">
                <label for="password" translate>{{eAuthMessages.PASSWORD}}</label>
                <input type="password" id="password" name="password" class="form-control" placeholder="password"
                  autocomplete="password" [formControl]="controlPassword" (keydown.enter)="login()">
                <div class="frankli-form-group-alert">
                  <ng-container *ngIf="state.submitted">
                    <div *ngIf="controlPassword.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                  </ng-container>
                </div>
              </div>
    
              <div class="frankli-form-group-alert">
                <div>{{state.errorMessage}}</div>
              </div>
    
              <div class="p-top-15 text-center">
                <app-button [loading]="state.loading" (onClick)="login()">
                  <span translate>{{eAuthMessages.SIGN_IN}}</span>
                </app-button>
              </div>
    
              <div class="p-top-15 p-bottom-15 text-center">
                <a routerLink="/auth/forgot-password" translate>{{eAuthMessages.FORGOT_PASSWORD}}</a>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="hidden">
  <div #buttonSSOMicrosoft>
    <app-login-sso-microsoft-component (buttonClick)="ssoLogin($event)"></app-login-sso-microsoft-component>
  </div>
  <div #buttonSSOGoogle>
    <app-login-sso-google-component (buttonClick)="ssoLogin($event)"></app-login-sso-google-component>
  </div>
</div>
